import { combineReducers } from 'redux';

import userReducer from './reducers/user.reducer';
import sellerReducer from './reducers/seller.reducer';
import logisticMemberReducer from './reducers/logistic.reducer';
import terminalsReducer from './reducers/terminals.reducer';
import bidsReducer from './reducers/bids.reducer';
import dwollaReducer from './reducers/dwolla.reducer';

const rootReducer = combineReducers({
    userStore: userReducer,
    sellerStore: sellerReducer,
    logisticMemberStore: logisticMemberReducer,
    terminalsStore: terminalsReducer,
    bidsStore: bidsReducer,
    dwollaStore: dwollaReducer
});

export default rootReducer;